import { connect } from "react-redux";
import { get } from "lodash";
import { updateRoProspect } from "../../../../../../store/actions/appConfig";
import { getOrganizationInfoRO } from "../../../../../../store/selectors/appConfig";
import { OutwardChequesComponent } from "./OutwardCheques";

const mapStateToProps = state => ({
  outwardCheque: get(getOrganizationInfoRO(state), "outwardCheque", [""])
});

const mapDispatchToProps = {
  updateRoProspect
};

export const OutwardCheques = connect(
  mapStateToProps,
  mapDispatchToProps
)(OutwardChequesComponent);
